import { useState } from "react";
import { motion } from "framer-motion";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setEmail("");
  };

  return (
    <section className="bg-[#F8F3E7] px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] bg-[#0F766E] px-5 py-12 text-center text-white shadow-2xl sm:px-10 sm:py-16">
        <div className="absolute -right-20 -top-20 h-56 w-56 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-black/10 blur-2xl" />
        <div className="relative">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D7EFEB]">A1 Rugs journal</p>
          <h2 className="mt-4 text-3xl font-bold sm:text-4xl lg:text-5xl">New rugs. New stories.</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-white/75 sm:text-base">Be the first to hear about new handmade rug arrivals, collection highlights, and special offers.</p>
          <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" aria-label="Email address" required className="min-w-0 flex-1 rounded-full border border-white/20 bg-white px-5 py-3.5 text-slate-800 outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-white/60" />
            <button type="submit" className="rounded-full bg-[#F8F3E7] px-7 py-3.5 text-sm font-bold text-[#0F766E] transition hover:bg-white hover:shadow-lg">Subscribe</button>
          </form>
          {submitted && <p className="mt-4 text-sm font-medium text-[#D7EFEB]">Thank you for subscribing!</p>}
          <p className="mt-5 text-xs text-white/50">No spam. Just new rugs and occasional updates.</p>
        </div>
      </motion.div>
    </section>
  );
}
